/**
 * Sample class for unit testing
 *
 * @namespace APP
 * @name APP.TestExample
 */

var APP = APP || function () {
	'use strict';
};

APP.TestExample = (/** @lends APP.TestExample */function () {
	'use strict';

	var exports;

	/**
	 * Add to number and return the sum of them
	 *
	 * @inner
	 * @public
	 * @memberof APP.TestExample
	 * @param {Number} numberOne - the first number
	 * @param {Number} numberTwo - the second number
	 * @returns {Number} - the sum of the 2 numbers
	 */
	function addNumbers(numberOne, numberTwo) {
		return numberOne + numberTwo;
	}

	/**
	 * Add a class to an element
	 *
	 * @inner
	 * @public
	 * @memberof APP.TestExample
	 * @param {jQuery} $elem - the element which should get the class
	 * @returns {void}
	 */
	function addClass($elem) {
		$elem.addClass('test-class');
	}

	exports = {};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {
		addNumbers: addNumbers,
		addClass: addClass
	};
	/* end-test-code */

	return exports;

}());
